import firebase from "firebase";
const config = {
  apiKey: "AIzaSyBUhUJjz4bKVe884UTH81JSXGcozyA-cC0",
  authDomain: "fabbi-ecs.firebaseapp.com",
  databaseURL: "https://fabbi-ecs.firebaseio.com",
  projectId: "fabbi-ecs",
  storageBucket: "fabbi-ecs.appspot.com",
  messagingSenderId: "749871036891",
  appId: "1:749871036891:web:d5af823517dfd992588ffe",
  measurementId: "G-8VYM6BSSPR"
};

firebase.initializeApp(config);
export default firebase;
